import React from 'react';
import SolutionChoiceProductContainer from 'containers/SolutionChoiceProductContainer/SolutionChoiceProductContainer';

export default function SolutionChoiceProductPage() {
    return (
        <SolutionChoiceProductContainer />
    )
}
